import { Box, Typography } from '@mui/material';

import RunSummaryAgentDrilldown from './RunSummaryAgentDrilldown';
import RunSummaryAgentList from './RunSummaryAgentList';
import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function PlatformReportPanel({
  description,
  drilldownProps,
  items = [],
  keyRisks,
  platform,
  recommendedActions,
}) {
  return (
    <Box sx={runSummaryAgentReportStyles.platformReportContent}>
      <Box sx={runSummaryAgentReportStyles.reportPanel}>
        <Typography variant="subtitle1" sx={runSummaryAgentReportStyles.sectionTitle}>
          {platform} Report
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>

      <RunSummaryAgentDrilldown items={items} {...drilldownProps} />

      <Box sx={runSummaryAgentReportStyles.trendGrid}>
        <Box sx={runSummaryAgentReportStyles.reportPanel}>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
            {platform} Key Risks
          </Typography>
          <RunSummaryAgentList items={keyRisks} />
        </Box>
        <Box sx={runSummaryAgentReportStyles.reportPanel}>
          <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
            {platform} Recommended Actions
          </Typography>
          <RunSummaryAgentList items={recommendedActions} />
        </Box>
      </Box>
    </Box>
  );
}
